export const BASEURL = process.env.REACT_APP_BASEURL;
export const PRE_BASEURL = process.env.REACT_APP_PRE_BASEURL;
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const STRIPE_KEY=process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
export const TASK_BASEURL=process.env.REACT_APP_TASK_SERVER_BASE_URL;
